<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex mb-3">
          <div class="pl-1">
            <h4>Lịch sử Vào/Ra công ty</h4>
          </div>
          <div class="text-right">
            <div>
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                round
                class="btn-default"
              >
                Ẩn/hiện tìm kiếm
              </el-button>
            </div>
          </div>
        </div>
        <div class="main-body mt-1">
          <!-- Form search -->
          <div class="main-body-search mb-3 b-shadow">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
            >
              <el-card>
                <el-form
                  ref="mySearchForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="120px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Nhân viên">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.employee_no"
                          clearable
                          filterable
                          placeholder="Nhập nội dung và enter để tìm kiếm"
                          no-data-text="Không có dữ liệu"
                          :filter-method="remoteSearchEmployee"
                          :loading="loadingSearchEmployee"
                          @keyup.enter.native="fn_enterFindEmployee()"
                        >
                          <el-option
                            v-for="item in listEmployeeSearch"
                            :key="item.employee_no"
                            :label="`${item.employee_no} - ${item.administrative_info.name.full_name}`"
                            :value="item.employee_no"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col lg="4">
                      <el-form-item label="Thời gian từ" prop="start_time">
                        <el-date-picker
                          type="datetime"
                          v-model="mData.tableRules.dataSearch.value.start_time"
                          prefix-icon="isax-calendar-1"
                          format="dd/MM/yyyy HH:mm"
                          @focus="fn_setDefaultHour('timeFrom')"
                          @change="fn_checkValidTimeFilter"
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col lg="4">
                      <el-form-item label="Thời gian tới" prop="">
                        <el-date-picker
                          type="datetime"
                          v-model="mData.tableRules.dataSearch.value.end_time"
                          prefix-icon="isax-calendar-1"
                          clearable
                          format="dd/MM/yyyy HH:mm"
                          @focus="fn_setDefaultHour('timeTo')"
                          @change="fn_checkValidTimeFilter"
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      round
                      class="btn-default"
                      native-type="submit"
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-card>
            </b-collapse>
          </div>

          <div class="main-body-table">
            <el-table
              :data="mData.tableRules.data"
              border
              style="width: 100%"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="employee_name"
                label="Tên nhân viên"
                min-width="150"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.employee_name"
                  >
                    <div class="content" slot="reference">
                      <span class="content">{{ scope.row.employee_name }}</span>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="employee_no"
                label="Mã chấm công"
                min-width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="time"
                label="Thời gian"
                min-width="150"
                align="center"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  {{ fn_formatDatetimeToSeconds(scope.row.time) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="serial"
                label="Thiết bị"
                min-width="200"
                align="center"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.serial"
                  >
                    <div class="content" slot="reference">
                      <span class="content">{{ scope.row.serial }}</span>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-12 text-right">
                <el-pagination
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from "../../../../../service/MethodService";
import EntryAndExitHistoryCompanyModel from "./EntryAndExitHistoryCompanyModel";
import TimeKeepingRawCurrentApi from "../../../../../moduleApi/TimeKeepingRawCurrentApi";
import EmployeeApi from "../../../../../moduleApi/EmployeeApi";

export default {
  data() {
    return {
      salaryPeriodId: undefined,
      currentUser: MethodService.getCurrentUser(),
      currentCompany: MethodService.getCompanyInfo(),
      mData: {
        data: [],
        moduleName: "EntryAndExitHistoryCompanyList",
        tableRules: MethodService.copyObject(EntryAndExitHistoryCompanyModel.tableRules),
        dataPerPage: [],
        start_time: '',
        end_time: '',
        dataDefault: {
          listEmployee: [],
        }
      },
      totalData: [],
      dataSalaryPeriod: [],
      timeKeepingLogApiRes: "",
      timeKeepingLogEmployeeApiRes: "",
      dataFilter: {},
      textFindEmployee: undefined,
      loadingSearchEmployee: false,
      listEmployeeSearch: [],
    };
  },

  methods: {
    remoteSearchEmployee(queryString) {
      if (!queryString) return;
      this.textFindEmployee = queryString.trim();
      this.listEmployeeSearch = [];
    },
    async fn_enterFindEmployee() {
      this.loadingSearchEmployee = true;
      const res = await EmployeeApi.list(
        {
          filters: `$vn_text=${this.textFindEmployee}`,
          limit: 50
        },
        true
      );
      this.listEmployeeSearch = res.result;
      this.loadingSearchEmployee = false;
    },
    async fn_getListEmployee() {
      const employeeApiRes = await EmployeeApi.list({
        fields: 'administrative_info,employee_no',
        limit: 5000
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.mData.dataDefault.listEmployee = employeeApiRes.result;
      }
    },

    async fn_initData() {
      this.mData.tableRules.dataSearch.value.start_time = this.mData.tableRules.dataSearch.value.start_time ? this.mData.tableRules.dataSearch.value.start_time : new Date().setHours(0, 0, 0);
      this.mData.tableRules.dataSearch.value.end_time = this.mData.tableRules.dataSearch.value.end_time ? this.mData.tableRules.dataSearch.value.end_time : new Date().setHours(23, 59, 59);
      await this.fn_getListEmployee();
      await this.fn_initTable();
    },

    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        employee_no: this.mData.tableRules.dataSearch.value.employee_no ? this.mData.tableRules.dataSearch.value.employee_no : null,
        start_time: this.mData.tableRules.dataSearch.value.start_time ? new Date(this.mData.tableRules.dataSearch.value.start_time).toISOString() : null,
        end_time: this.mData.tableRules.dataSearch.value.end_time ? new Date(this.mData.tableRules.dataSearch.value.end_time).toISOString() : null,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.skip = this.mData.tableRules.offset;
        dataFilter.page = this.mData.tableRules.page;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-Timekeeping-TimekeepingConfig-" + this.mData.moduleName,
            query: {
              ...dataFilter
            },
          })
          .catch((err) => {});
      }
      let res = await TimeKeepingRawCurrentApi.GetTimeKeepingLog(dataFilter);
      this.mData.tableRules.total = res.meta.total;
      if (res.result && res.result.result && res.result.result.length > 0) {
        this.mData.tableRules.data = await this.fn_changeData(res.result.result);
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
      } else {
        this.mData.tableRules.data = [];
      }
      if (
          this.mData.tableRules.offset == this.mData.tableRules.total &&
          this.mData.tableRules.page > 1
      ) {
          this.mData.tableRules.page = this.mData.tableRules.page - 1;
          this.mData.tableRules.offset =
            (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
          await this.fn_initTable();
      }
    },

    fn_changeData(resData) {
      resData.forEach(item => {
        const emp = this.mData.dataDefault.listEmployee.find(emp => emp.employee_no == item.employee_no);
        item.employee_name = emp ? emp.administrative_info.name.full_name : '';
      });
      return resData;
    },

    fn_formatDatetimeToSeconds(val) {
      return MethodService.formatDateToSeconds(val);
    },

    fn_setDefaultHour(timeType) {
      if (timeType == 'timeFrom' && !this.mData.tableRules.dataSearch.value.start_time) {
        this.mData.tableRules.dataSearch.value.start_time = new Date().setHours(0,0,0);
      } else if (timeType == 'timeTo' && !this.mData.tableRules.dataSearch.value.end_time) {
        this.mData.tableRules.dataSearch.value.end_time = new Date().setHours(23,59,59);
      }
    },

    fn_checkValidTimeFilter() {
      if (this.mData.tableRules.dataSearch.value.start_time && this.mData.tableRules.dataSearch.value.end_time) {
        const start_time = new Date(this.mData.tableRules.dataSearch.value.start_time).getTime();
        const end_time = new Date(this.mData.tableRules.dataSearch.value.end_time).getTime();
        if (start_time > end_time) {
          this.mData.tableRules.dataSearch.value.end_time = '';
          window.toastr.warning(
            "Mốc 'Thời gian tới' phải lớn hơn hoặc bằng mốc 'Thời gian từ' !"
          );
        }
      }
    },

    //event table
    async fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = 1;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = -1;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.mData.tableRules.data = [];
      await this.fn_initTable();
    },

    //search
    fn_tableSearch() {
      this.$refs["mySearchForm"].validate(async (valid) => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
            "company_id=system",
            "company_id:is_null:true"
          );
          this.mData.tableRules.page = 1;
          this.mData.tableRules.offset = 0;
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-Timekeeping-TimekeepingConfig-" + this.mData.moduleName,
        query: query,
      });
    },

    //event table by transmitting skip and limit
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(1);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    async fn_getListEmployeeByEmployeeNo(employeeNo) {
      this.loadingSearchEmployee = true;
      const res = await EmployeeApi.list(
        {
          filters: `employee_no=${employeeNo}`,
          limit: 50
        },
        true
      );
      this.listEmployeeSearch = res.result;
      this.loadingSearchEmployee = false;
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
      }
      if (this.$route.query.employee_no) {
        this.mData.tableRules.dataSearch.value.employee_no = this.$route.query.employee_no;
      }
      if (this.mData.tableRules.dataSearch.value.employee_no) {
        this.fn_getListEmployeeByEmployeeNo(this.mData.tableRules.dataSearch.value.employee_no);
      }
      if (this.$route.query.start_time) {
        this.mData.tableRules.dataSearch.value.start_time = new Date(this.$route.query.start_time);
      } else if (this.$route.query.end_time) {
        this.mData.tableRules.dataSearch.value.end_time = new Date(this.$route.query.end_time);
      }
    },
  },

  //run after render view
  async created() {
    await this.fn_hashUrl();
    await this.fn_initData();
  },
  mounted() {}
};
</script>
<style scoped>
::v-deep .el-input__filter .el-input__inner {
  text-overflow: ellipsis;
}
/* ::v-deep .el-input__prefix, .el-input__suffix {
  right: 5px;
  left: auto;
} */
/* ::v-deep .el-input--suffix .el-input__inner {
  padding-left: 15px;
  padding-right: 15px;
} */
</style>
